/*
  ms-cart-bundle.js — "Køb sammen med" i indkøbskurven (instant add).

  Hver række i snippets/ms-cart-bundle.liquid har en [data-ms-cart-bundle-add]-knap.
  Klik → læs valgt variant (størrelses-<select> ellers data-variant-id) → POST til
  /cart/add.js (med drawer-sektionen i 'sections') → publish theme.pubsub cartUpdate.

  Det er PRÆCIS samme flow som temaets egen ProductForm.onSubmitHandler: cart-items
  (i cart.js) lytter på cartUpdate og re-renderer #MiniCart fra cart.sections, og
  header-kurvtælleren opdateres af samme event. Draweren forbliver åben.

  Event delegation på document → overlever alle innerHTML-swaps uden re-bind.
  Guarded mod dobbelt-init.
*/
(function () {
  if (window.__msCartBundleInit) return;
  window.__msCartBundleInit = true;

  function drawerSectionId() {
    var d = document.getElementById('CartDrawer');
    return d ? d.getAttribute('data-section-id') : null;
  }

  function addConfig(body) {
    var cfg = (window.theme && theme.utils && theme.utils.fetchConfig)
      ? theme.utils.fetchConfig('javascript')
      : { method: 'POST', headers: {} };
    cfg.headers = cfg.headers || {};
    cfg.headers['Content-Type'] = 'application/json';
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    cfg.body = body;
    return cfg;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-cart-bundle-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();

    var row = btn.closest('[data-ms-cart-bundle-row]');
    var select = row ? row.querySelector('.ms-cart-bundle__size') : null;
    var variantId = (select && select.value) ? select.value : btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart.js';
    var sid = drawerSectionId();

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sid) { body.sections = [sid]; body.sections_url = window.location.pathname; }

    btn.setAttribute('aria-busy', 'true');

    fetch(addUrl, addConfig(JSON.stringify(body)))
      .then(function (r) { return r.json(); })
      .then(function (added) {
        if (added && added.status) {
          btn.removeAttribute('aria-busy');
          return null;
        }
        var getCfg = (window.theme && theme.utils && theme.utils.fetchConfig)
          ? theme.utils.fetchConfig('json', 'GET')
          : { method: 'GET', headers: {} };
        return fetch(cartUrl, getCfg).then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = added.sections;
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ms-cart-bundle', cart: cart });
          } else {
            // Fallback: bed drawer-elementet re-rendere sig selv
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          }
        });
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });
})();
